import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useBrand = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);
  return environment.brand;
};
